<template lang="html">
  <span
    class="helper"
    data-toggle="popover"
    :title="title"
    :data-placement="placement"
    :data-trigger="trigger"
    data-template='
      <div class="popover popover-helper" role="tooltip">
        <div class="arrow"></div>
        <h3 class="popover-header"></h3>
        <div class="popover-body"></div>
      </div>
    '
    :data-content="$slots.default[0].text"
  >
    <v-icon name="helper" />
  </span>
</template>

<script>
export default {
  props: {
    title: {},
    placement: {
      default: 'top',
    },
    trigger: {
      default: 'hover',
    },
  },
  mounted() {
    this.$nextTick(function() {
      jQuery('.helper').popover();
    });
  },
};
</script>

<style lang="scss">
.helper {
  cursor: pointer;
}
.popover-helper {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/parts/components/helper.vue